var Mn = require('backbone.marionette'),
    _ = require('underscore'),
    $ = require('jquery'),
    scope = require('scope');

require('jquery-validation');
require('jquery-mask-plugin');
require('jquery-modal');
require('@chenfengyuan/datepicker');
require('@chenfengyuan/datepicker/i18n/datepicker.pt-BR');
require('select2');
require('select2/dist/js/i18n/pt-BR');

var masks = {
    money: '#.##0,00',
    bankBranchWithoutDigit: '#',
    bankBranch: '0000-0',
    bankAccount: '#-9',
    dynamic: 'X',
    cep: '00000-000',
    date: '00/00/0000',
    cpf: '000.000.000-00',
    cnpj: '00.000.000/0000-00',
    phone: '(00) 90000-0000',
    creditCard: '0000 0000 0000 0000',
    barcodeBoleto: '00000.00000 00000.000000 00000.000000 0 00000000000000',
    barcodeConvenio: '00000000000 0 00000000000 0 00000000000 0 00000000000 0'
}

$.jMaskGlobals.translation.X = {
    pattern: /./,
    recursive: true
};

// Mascara para Dinheiro e Decimais (Primeira versão da funcionalidade, fora do plugin, apenas como opções adicionais)
// Fonte: https://github.com/igorescobar/jQuery-Mask-Plugin/issues/527 point to >>> http://jsfiddle.net/c6qj0e3u/11/
// Editado por: Pyetro >>> http://jsfiddle.net/c6qj0e3u/15/
// Nova funcionalidade: Verifica valor do campo de é 0,00 e pressiona Backspace, limpa o campo
var MoneyOpts = {
    reverse: true,
    maxlength: false,
    placeholder: '0,00',
    eventNeedChanged: false,
    onKeyPress: function (v, ev, curField, opts) {
        var mask = curField.data('mask').mask;
        var decimalSep = (/0(.)00/gi).exec(mask)[1] || ',';
        if (curField.data('mask-isZero') && curField.data('mask-keycode') == 8)
            $(curField).val('');
        else if (v) {
            // remove previously added stuff at start of string
            v = v.replace(new RegExp('^0*\\' + decimalSep + '?0*'), ''); //v = v.replace(/^0*,?0*/, '');
            v = v.length == 0 ? '0' + decimalSep + '00' : (v.length == 1 ? '0' + decimalSep + '0' + v : (v.length == 2 ? '0' + decimalSep + v : v));
            $(curField).val(v).data('mask-isZero', (v == '0' + decimalSep + '00'));
        }
    }
};

// Mascara para Telefone padrão 8 e 9 dígitos
// Fonte: https://github.com/igorescobar/jQuery-Mask-Plugin/issues/527
// Conforme exemplo do criador: http://igorescobar.github.io/jQuery-Mask-Plugin/js/examples.js
var SPMaskBehavior = function (val) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
},
    spOptions = {
        onKeyPress: function (val, e, field, options) {
            field.mask(SPMaskBehavior.apply({}, arguments), options);
        }
    };

var Form =  Mn.Behavior.extend({
    ui: {
        'form': 'form:not([data-form-bypass])',
        'stateSelect': '[data-state-select]',
        'citySelect': '[data-city-select]'
    },
    events: {
        'change @ui.stateSelect': 'selectStateLoadCities'
    },
    onAttach: function () {
        this.onRender.apply(this)
    },
    onRender: function () {
        this.onBuild.apply(this)
    },
    onBuild: function () {
        var self = this;

        this.ui.form.each(function () {
            if ($(this).data('form-listener')) return;

            $(this).data('form-listener', true);

            self.formListener($(this));
        })
    },
    selectStateLoadCities: function(e) {
        var self = this,
            $selectElm = $(e.target),
            cityParent = self.ui.citySelect.parent();
        self.$el.find('[data-reset-on*="estado"]').each(function () {
            $(this).attr('readonly','true').html('<option value="">Escolha</option>').val("").trigger('change').attr('readonly','true');
        });
        self.ui.citySelect.html('<option value="">Cidade</option>');
        cityParent.addClass('loading');
        $.ajax({
            url: self.ui.citySelect.data('city-select').replace('%stateId%', $selectElm.val()),
            type: 'GET',
            dataType: 'json',
            success: function (data) {
                self.ui.citySelect.html('<option value="">Cidade</option>');
                $('[data-state-clear]').val('');
                var $elms = $.each(data, function(idx, elm) {
                    if(idx == '' && elm == '') return;
                    
                    var opt = new Option(elm.label, elm.value, false, false);
                    $(opt).appendTo(self.ui.citySelect);
                });
                if (data.length == 1) {
                    self.ui.citySelect.val(data[0].value).trigger('change').attr('readonly', true);
                } else {
                    self.ui.citySelect.attr('readonly', false);
                }
                // self.ui.citySelect.trigger('change');
            },
            complete: function() {
                cityParent.removeClass('loading');
            }
        });
    },
    formListener: function (form) {
        var self = this;
        var BankBranchMaskBehavior = function (val) {
            val = val.replace(/\D/g, '');
            return val.length <= '4' ? masks.bankBranchWithoutDigit : masks.bankBranch;
        },
            BankBranchOptions = {
                reverse: true,
                maxlength: true,
                eventNeedChanged: false,
                onKeyPress: function (val, e, field, options) {
                    field.unmask();
                    field.mask(BankBranchMaskBehavior.apply({}, arguments), options);
                }
            };

        $('.mask_money, [data-rule-money]', form).mask(masks.money, MoneyOpts).parent().addClass('isMoney');
        $('.mask_bank, [data-rule-bank]', form).mask(BankBranchMaskBehavior, BankBranchOptions);
        $('.mask_bankaccount, [data-rule-bankaccount]', form).mask(masks.bankAccount, {
            reverse: true,
            maxlength: false,
            eventNeedChanged: false,
        });

        $('.mask_credit_card, [data-rule-credit-card]', form).mask(masks.creditCard);
        $('.mask_cep, [data-rule-cep]', form).mask(masks.cep);
        $('.mask_datepicker, [data-rule-datepicker]', form).mask(masks.date).datepicker({
            language: 'pt-BR'
        });
        $('.mask_date, [data-rule-date], .mask_datepicker, [data-rule-datepicker]', form).mask(masks.date);
        $('.mask_cpf, [data-rule-cpf]', form).mask(masks.cpf);
        $('.mask_cnpj, [data-rule-cnpj]', form).mask(masks.cnpj);
        $('.mask_phone, [data-rule-phone]', form).mask(SPMaskBehavior, spOptions);

        $('[data-customselect]').each(function (idx, select) {
            var $select = $(select);
            $select.select2({
                theme: 'simple',
                // width: '100%',
                placeholder: $select.attr('placeholder')
            });
        });

        function placeholderFocus(e){
            var placeholder = $(this).parents('.placelabel');

            if(placeholder.length){
                placeholder.addClass('ontop');
            }
        }

        function placeholderBlur(e){
            var placeholder = $(this).parents('.placelabel');
            var originalval = $(this).val();

            var hiddenval = $($(this).data('hidden-value'));

            if(hiddenval.length > 0){
                originalval = hiddenval.val();
            }

            if(placeholder.length > 0 && originalval == ''){
                placeholder.removeClass('ontop');
            }else{
                placeholder.addClass('ontop');
            }
        }

        $('body').on('focus', '.placelabel input, .placelabel  select, .placelabel .custom-multiselect', placeholderFocus);

        $('body').on('blur change', '.placelabel input, .placelabel  select, .placelabel .custom-multiselect', placeholderBlur);

        $('.placelabel input, .placelabel  select, .placelabel .custom-multiselect', form).each(function(){
            placeholderBlur.apply(this, []);
        })

        var BarCodeMaskBehavior = function (val) {
            return val[0] === '8' ? masks.barcodeConvenio : masks.barcodeBoleto;
        },
            BarCodeOptions = {
                onKeyPress: function (val, e, field, options) {
                    field.mask(BarCodeMaskBehavior.apply({}, arguments), options);
                }
            };

        $('.mask_barcode, [data-rule-barcode]', form).mask(BarCodeMaskBehavior, BarCodeOptions);

        $('.mask_document, [data-rule-document]', form)
            .on('paste', function (e) {
                var pastedData = e.originalEvent.clipboardData.getData('text').replace(/\D/g, '');
                $(this).mask((pastedData.length <= 11) ? masks.cpf : masks.cnpj).val(pastedData);
            })
            .on('keydown', function (e) {
                try {
                    var digit = !!e.key ? e.key.replace(/\D/g, '') : '';
                    var value = $(this).val().replace(/\D/g, '');


                    if (/^[0-9]/.test(value)) {
                        var size = value.concat(digit).length;
                        $(this).mask((size <= 11) ? masks.cpf : masks.cnpj);
                    }
                } catch (e) { }
            });

        $(document).on('keypress', '.mask_login, [data-rule-login]', function (e) {
            try {
                var digit = e.key.replace(/\D/g, '');
                var value = $(this).val();
                var valueDocs = $(this).val().replace(/\D/g, '');

                // se digitar letras, retira mask, caso contrário continua o processo
                if (event.keyCode >= 65 && event.keyCode <= 122 || value.match(/[a-z]/i)) {
                    $(this).unmask();
                } else {
                    var size = valueDocs.concat(digit).length;
                    $(this).mask((size <= 11) ? masks.cpf : masks.cnpj);
                }
            } catch (e) { }
        });

        var ctrlDown = false,
            ctrlKey = 17,
            cmdKey = 91,
            vKey = 86,
            cKey = 67;

        $(document).on('keydown', '.mask_login, [data-rule-login]', function(e) {
            if (e.keyCode == ctrlKey || e.keyCode == cmdKey) ctrlDown = true;
        }).on('keyup', '.mask_login, [data-rule-login]', function(e) {
            if (e.keyCode == ctrlKey || e.keyCode == cmdKey) ctrlDown = false;
        });

        // Document Ctrl + C/V
        $(document).on('keydown', '.mask_login, [data-rule-login]', function(e) {
            if (ctrlDown && (e.keyCode == vKey)) $(this).unmask();
        });

        $(document).on('focusout blur', '.mask_login, [data-rule-login]', function (e) {
            var valueDocs = $(this).val().replace(/\D/g, '');
            var value = $(this).val();
            var size = valueDocs.length;

            // se digitar letras, retira mask, caso contrário continua o processo
            if (value.match(/[a-z]/i)) {
                $(this).unmask();
            } else {
                $(this).mask((size <= 11) ? masks.cpf : masks.cnpj);
            }
        });

        $(document).on('change', '[data-rule-barcode]', function (e) {
            var $this = $(this)

            if ($this.valid()) {
                var codeutil, value = null, days = null,
                    inputVal = $this.val()

                if (inputVal[0] === '8') {
                    codeutil = inputVal.replace(/[^\d]+/g, '')

                    var fields = [];
                    for (var fieldSet = 0; fieldSet < 4; ++fieldSet) {
                        fields.push(codeutil.substr(fieldSet * 12, 12));
                    }
                    codeutil = fields.map(function (e) { return e.substr(0, 11); }).join('');

                    if (codeutil[2] === '6' || codeutil[2] === '8') {
                        value = parseInt(codeutil.substr(4, 11));

                        days = codeutil.substr(19, 8);
                    }

                    if ($('[data-form-nominal-value]')) {
                        $('[data-form-nominal-value]')
                            .val(parseInt(value))
                            .prop('readonly', value != null && value > 0)
                            .trigger('input')
                            .change();
                    }
                    if ($('[data-form-pay-date]')) {
                        days = moment(days, 'YYYYMMDD');

                        $('[data-form-pay-date]')
                            .val(days.isValid() ? days.format('DD/MM/YYYY') : '')
                            .prop('readonly', days.isValid())
                            .trigger('input')
                            .change();
                    }
                } else {
                    codeutil = inputVal.split(' ')
                    codeutil = codeutil[codeutil.length - 1]

                    value = codeutil.substr(4)
                    days = codeutil.substr(0, 4)

                    if ($('[data-form-nominal-value]')) {
                        $('[data-form-nominal-value]')
                            .val(parseInt(value))
                            .prop('readonly', value != null && value > 0)
                            .trigger('input')
                            .change();
                    }

                    if ($('[data-form-pay-date]')) {
                        days = moment('07/10/1997', 'DD/MM/YYYY').add(days, 'days');
                        $('[data-form-pay-date]')
                            .val(days.isValid() ? days.format('DD/MM/YYYY') : '')
                            .prop('readonly', days.isValid())
                            .trigger('input')
                            .change();

                    }
                }
            }
        })

        $(document).on('change', '[data-form-total-partial]', function (e) {
            if ($('[data-form-total]')) {
                var total = 0;

                $('[data-form-total-partial]').each(function () {
                    if ($(this).data('form-total-partial') === 'plus') {
                        total += parseInt($(this).val() ? $(this).val().replace(/[^\d]+/g, '') : 0);
                    } else if ($(this).data('form-total-partial') === 'minus') {
                        total -= parseInt($(this).val() ? $(this).val().replace(/[^\d]+/g, '') : 0);
                    }
                });

                $('[data-form-total]').val(total).trigger('input').change();
            }
        })

        if(self.ui.stateSelect.length > 0){
            var stateParent = self.ui.stateSelect.parent();
            stateParent.addClass('loading');
            $.ajax({
                url: self.ui.stateSelect.data('state-select'),
                type: 'GET',
                dataType: 'json',
                success: function (data) {
                    self.ui.stateSelect.html('<option value="">UF</option>');
                    var $elms = $.each(data, function(idx, elm) {
                        if(idx == '' && elm == '') return;
                        
                        var opt = new Option(elm.label, elm.value, false, false);
                        $(opt).appendTo(self.ui.stateSelect);
                    });
                    self.ui.stateSelect.removeAttr('readonly');

                    if (data.length == 1) {
                        self.ui.stateSelect.val(data[0].value).trigger('change').attr('readonly', true);
                    } else {
                        self.ui.stateSelect.attr('readonly', false);
                    }
                },
                complete: function() {
                    stateParent.removeClass('loading');
                }
            });
        }

        form.find('input[data-ajax-file]').each(function () {
            var el = $(this);
            var executeAjaxFile = function (token) {
                var fileValue = $(el.data('ajax-file'));
                var url = el.data('url');
                var formData = new FormData();
                formData.append(el.attr('name'), el[0].files[0]);

                if(el.data('csrf')){
                    formData.append('_token', el.data('csrf'));
                }
                if (token) {
                    formData.append('g-recaptcha-response', token);
                }

                $.ajax({
                    url: url,
                    type: 'POST',
                    data: formData,
                    processData: false,  // tell jQuery not to process the data
                    contentType: false,  // tell jQuery not to set contentType
                    dataType: 'json',
                    success: function (data) {
                        if (data && data.image) {
                            fileValue.val(data.image.id);
                            el.parent().find('img').attr('src', data.image.imageUrl);
                        }
                    }, 
                    complete : function () {
                        var captcha = $('.render-captcha--'+$(el).attr('data-captcha'));
                        if (captcha.length) {
                            grecaptcha.reset(captcha.data('captcha-id'));
                        }
                    }
                });
            } 
            $(this).on('change', function () {
                var captcha = $('.render-captcha--'+$(el).attr('data-captcha'));
                if (captcha.length) {
                    var promise = captcha.data('captcha-promise');
                    if (promise) {
                        promise.progress(executeAjaxFile);
                        captcha.data('captcha-promise', false);
                    }
                    grecaptcha.execute(captcha.data('captcha-id'));
                } else {
                    executeAjaxFile();
                }
            })
            
            
        });

        form.find('input[data-button-toggle]').change(function () {
            var btn = $($(this).data('button-toggle'));

            if ($(this).is(':checked')) {
                btn.removeAttr('disabled');
            } else {
                btn.attr('disabled', 'disabled');
            }
        });

        var enablesubmit = form.data('enable-submit');

        if (!enablesubmit) {
            var inputsubmit = form.find('input[type="submit"],button[type="submit"]');

            inputsubmit.attr('disabled', 'disabled');

            form.on('change', 'input,select,textarea', function () {
                if (!form.data('disabled')) inputsubmit.removeAttr('disabled');
            }).on('keyup', function () {
                if (!form.data('disabled')) inputsubmit.removeAttr('disabled');
            });
        }

        var disablesubmitfor = form.data('disable-submit-for');

        if (disablesubmitfor) {
            var disablesubmitforForm = $(disablesubmitfor).find('form');
            var disablesubmitforSubmit = $(disablesubmitforForm).find('input[type="submit"],button[type="submit"]');

            form.on('change', 'input,select,textarea', function () {
                disablesubmitforForm.data('disabled', true);
                disablesubmitforSubmit.attr('disabled', 'disabled');
            });
        }
        this.rebuild(form);

        var addValidations = this.getOption('addValidations');
        if (addValidations && addValidations.call) {
            addValidations(form, this.view);
        }
    },
    onFormRebuild: function(form) {
        this.rebuild(form);
    },
    rebuild: function (form) {
        var self = this;
        form.validate({
            ignore: '.ignore',
            errorElement: 'span',
            errorLabelContainer: form.find('[data-error-container]'),
            invalidHandler: function (error, element) {
                if (element.errorList.length > 0) {
                    var elementError = $(element.errorList[0].element)
                    var tab = elementError.parents('[data-tabs-group]')
                    var tabId = tab.attr('id')
                    var tabGroup = tab.data('tabs-group')

                    var tabsactions = $('[data-tabs="' + tabGroup + '"]')
                    tabsactions.filter('[href="#' + tabId + '"]').trigger('click')

                    return false
                }
            },
            errorPlacement: function (error, element ) {
                if (element.attr('name') == 'g-recaptcha-response') {
                    error.appendTo(element.closest('.formcaptcha'));
                } else if (element.closest('[data-field-holder]').length) {
                    error.appendTo(element.closest('[data-field-holder]'));
                } else if (element.closest('.fieldlabel').length) {
                    error.appendTo(element.closest('.fieldlabel'));
                } else if (element.closest('label').length) {
                    error.appendTo(element.closest('label'));
                } else {
                    error.insertAfter( element );
                }
            },
            highlight: function (element, errorClass, validClass) {
                $(element).removeClass(validClass).addClass(errorClass);
                $(element).closest("label, .fields, [data-field-holder]").removeClass(validClass).addClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass(errorClass).addClass(validClass);
                $(element).closest("label, .fields,[data-field-holder]").removeClass(errorClass).addClass(validClass);
            },
            submitHandler: function (e) {
                var executeOnSumitHandler = function () {
                    $('[data-double-click]').prop('disabled', true);

                    var disablesubmitfor = form.data('disable-submit-for');

                    if (disablesubmitfor) {
                        $(disablesubmitfor).find('form').data('disabled', false);
                        $(disablesubmitforForm).find('input[type="submit"],button[type="submit"]').removeAttr('disabled');
                    }

                    if (typeof form.attr('data-ajax-bypass') !== 'undefined') {
                        form[0].submit();
                        return true;
                    }

                    var serializeData = self.formSerialize(form);
                    var serializedFormData = new FormData();

                    form.find('input[type=file]').each(function () {
                        if (this.files && this.files[0]) {
                            serializedFormData.append($(this).attr('name'), this.files[0]);
                        }

                    });
                    form.find('[data-form-file]').each(function () {
                        serializedFormData.append($(this).attr('data-form-file'), $(this).data('file'));
                    });

                    if (form.data('set-formdata')){
                        $(serializeData).each(function () {
                        
                            serializedFormData.set(this.name, this.value);
                        });
                    }  else {
                        $(serializeData).each(function () {
                        
                            serializedFormData.append(this.name, this.value);
                        });
                    }
                    

                    var options = {
                        async: true,
                        crossDomain: true,
                        pushstate: true,
                        noscroll: true,
                        contentType: false, // NEEDED, DON'T OMIT THIS (requires jQuery 1.6+)
                        processData: false, // NEEDED, DON'T OMIT THIS
                        url: form.attr('action'),
                        method: form.attr('method'),
                        mimeType: form.attr('mimeType'),
                        dataType: 'json',
                        data: serializedFormData,
                        success: function (response) {
                            scope.setvars({
                                submitResponse: response
                            })

                            if (response.success) {
                                form.trigger('submitSuccess', [response, serializedFormData]);
                                
                                var successTab = form.data('success-tab');
                                var autoupdateurl = form.data('autoupdateurl');
                                var successRedirect = form.data('success-redirect');
                                var successModal = form.data('success-modal');
                                var successNextForm = form.data('success-next-form') || '';
                                
                                var errorTab = form.data('error-tab');
                                var errorModal = form.data('error-modal');

                                if (autoupdateurl) {
                                    scope.app.navigate(this.url, false);
                                }
                                
                                if(successTab){
                                    scope.tabs.selectTab('#' + successTab);

                                    form[0].reset();
                                }else if(successRedirect){
                                    scope.app.navigate(successRedirect, true);
                                }else if(response.redirect) {
                                    scope.app.navigate(response.redirect, false);
                                }else if (successNextForm.search('#form-') != -1) {
                                    var successNextFormElement = $(successNextForm);

                                    form.hide();
                                    self.formFeed(successNextFormElement, response.data);
                                    successNextFormElement.data('parent', form);
                                    successNextFormElement.show();
                                } else if (successModal && successModal.title) {
                                    $(
                                        '<div class="modal">' +
                                            '<div class="modal__wrapper">' +
                                                '<div class="modal__title">'+_.template(successModal.title)(response.data)+'</div>'+
                                                '<div class="modal__description">'+_.template(successModal.description)(response.data)+'</div>'+
                                                '<a class="modal__button" href="#" data-close-modal rel="modal:close" title="'+_.template(successModal.confirmationButton)(response.data)+'">' +
                                                '<svg xmlns="http://www.w3.org/2000/svg" width="7.41" height="12" viewBox="0 0 7.41 12">' +
                                                '<path data-name="Caminho 165" d="M15.41,7.41,14,6,8,12l6,6,1.41-1.41L10.83,12Z" transform="translate(15.41 18) rotate(180)"/> </svg>' +
                                                '<span>'+_.template(successModal.confirmationButton)(response.data) +'</span> </a>' +                                         
                                                (successModal.button ? (
                                                    '<a href="'+_.template(successModal.button.link)(response.data)+'" class="component-modal__button">'+_.template(successModal.button.name)(response.data)+'</div>'
                                                ) : '') +
                                            '</div>' +
                                        '</div>'
                                    ).modal();

                                    successModal.reset && form.trigger('reset');
                                }
                            }else{
                                form.trigger('submitError', [response]);

                                var errorRedirect = form.data('error-redirect');

                                if(errorRedirect){
                                    scope.app.navigate(errorRedirect, true);
                                    return;
                                }

                                if(errorTab){
                                    var tab = form.find('[data-tabs-group]')
                                    var tabGroup = tab.data('tabs-group')

                                    var tabsactions = $('[data-tabs="' + tabGroup + '"]')
                                        tabsactions.filter('[href="#' + errorTab + '"]').trigger('click');

                                    successModal.reset && form.trigger('reset');
                                }else if(errorModal && errorModal.title){
                                    $(
                                        '<div class="modal">' +
                                            '<div class="component-article__title">'+errorModal.title+'</div>'+
                                            '<div class="component-article__description">'+errorModal.description+'</div>'+
                                        '</div>'
                                    ).modal();

                                    successModal.reset && form.trigger('reset');
                                }
                                self.showError(form, response.message || '');
                            }

                            $('[data-double-click]').prop('disabled', false);

                        },
                        error: function (err) {
                            $('[data-double-click]').prop('disabled', false);
                            self.showError(form, err.responseJSON ? err.responseJSON : '');

                            form.trigger('submitError')
                        },
                        complete: function () {
                            if (form.find('.render-captcha').length) {
                                grecaptcha.reset(form.find('.render-captcha').data('captcha-id'));
                            }
                        }
                    };

                    form.trigger('beforeProcessRequest', [options]);

                    $.ajax(options);
                }
                if (form.find('.render-captcha').length) {
                    var promise = form.find('.render-captcha').data('captcha-promise');
                    if (promise) {
                        promise.progress(executeOnSumitHandler);
                        form.find('.render-captcha').data('captcha-promise', false);
                    }
                    grecaptcha.execute(form.find('.render-captcha').data('captcha-id'));
                } else {
                    executeOnSumitHandler();
                }
                return false;
            }
        });
    },
    formFeed: function (form, data) {
        for (var key in data) {
            form.find('[name="' + key + '"]').each(function () {
                $(this).val(data[key]);
            })
        }
    },
    formSerialize: function (form) {
        var self = this;
        var serialize = form.serializeArray();
        var fields = form.find([
            '.mask_cep, [data-rule-cep]',
            '.mask_cpf, [data-rule-cpf]',
            '.mask_cnpj, [data-rule-cnpj]',
            '.mask_document, [data-rule-document]',
            '.mask_phone, [data-rule-phone]'
        ].join(','));

        fields.each(function () {
            var input = $(this);
            var name = input.attr('name');
            var value = self.clearInputValue(input);

            self.changeSerializeValue(serialize, name, value);
        });

        var moneys = form.find('.mask_money, [data-rule-money]');
        moneys.each(function () {
            var input = $(this);
            var name = input.attr('name');
            var value = (input.val() || '').replace(/\./g, '').replace(',', '.');

            self.changeSerializeValue(serialize, name, value);
        });

        return serialize;
    },
    changeSerializeValue: function (serialize, name, value) {
        $(serialize).each(function () {
            if (this.name === name) {
                this.value = value;
            }
        });
    },
    clearInputValue: function (input) {
        return (input.val() || '').replace(/[^0-9]/g, '');
    },
    parseLaravelFieldKey: function(key) {
        var fieldNameArray = key.split('.'),
            fieldName = fieldNameArray[0];
        for(var i = 1; i<fieldNameArray.length; ++i) {
            fieldName += '[' + fieldNameArray[i] + ']'
        }

        return fieldName;
    },
    showError: function (form, message) {
        var self = this;
        var typeError = form.data('error');
        var parentForm = form.data('parent');

        if (parentForm) {
            form.hide();
            parentForm.show();
        }
        if (typeError && typeError.title) {
            $(
                '<div class="modal">' +
                '<div class="component-article__title">' + ((!!message && message.message && message.message.length) ? message.message : typeError.title) + '</div>' +
                '<div class="component-article__description">' + ((!!message && !!message.extrainfo && message.extrainfo.length) ? message.extrainfo : typeError.description) + '</div>' +
                '</div>'
            ).modal();

            if (parentForm) {
                parentForm.find('.formerrors').text('');
            } else {
                form.find('.formerrors').text('');
            }
            return;
        }

        if (message) {
            if (message.errors) {
                try {
                    var errors = {};
                    $.each(message.errors, function(key, value) {
                        errors[self.parseLaravelFieldKey(key)] = value;
                    });
                    message.errors = errors;
                    form.validate().showErrors(message.errors);

                    for (var key in message.errors) {

                        form.find('[name="' + key + '"][data-error-modal]').each(function () {
                            var modal = $(this).data('error-modal');
                            $('#' + modal).modal();
                        });
                    }
                    return;
                } catch (e) {
                    message = false;
                }
            } else if (message.success === false || message.exception || message.message) {
                if (!!message.message) {
                    message = message.message;
                } else {
                    message = false;
                }
            }
            var msg = (message && message !== '') ? message : 'Erro interno no servidor.';

            form.find('.formerrors').text(msg).show();
        } else {
            form.find('.formerrors').text('').hide();
        }
    }
});

$.extend($.validator.messages, {
    date: "Digite uma data válida.",
    digits: "Este campo só aceita dígitos",
    email: "Informe um email válido.",
    equalTo: "Os valores precisam ser iguais.",
    number: "Este campo só aceita números.",
    remote: "Campo inválido.",
    required: "Campo obrigatório.",
    url: "O endereço do site deve iniciar com http:// ou https://.",
    maxlength: $.validator.format("Campo deve conter no máximo {0} caracteres."),
    minlength: $.validator.format("Campo deve conter no mínimo {0} caracteres."),
    rangelength: $.validator.format("Campo deve conter de {0} até {1} caracteres."),
    range: $.validator.format("Apenas numeros de {0} até {1}."),
    max: $.validator.format("Apenas números até {0}."),
    min: $.validator.format("Apenas números a partir de {0}."),
    step: $.validator.format("Numeros multiplos de {0}."),
    'money-max': $.validator.format("O valor deve ser até R$ {0}."),
    'money-min': $.validator.format("O valor deve ser a partir de R$ {0}."),
    'branch': $.validator.format("Campo deve conter no mínimo {0} digitos.")
});

jQuery.validator.addMethod("date", function (value, element) {
    return this.optional(element) || /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(value);
}, "Informe uma data válida");
$.validator.addMethod('reCaptchaMethod', function (value, element, param) {

    if (param) {
        if (grecaptcha.getResponse(param) == ''){
            return false;
        } else {
            return true;
        }
    }
    else if (grecaptcha.getResponse() == ''){
        return false;
    } else {
        // I would like also to check server side if the recaptcha response is good
        return true
    }
}, 'Precisa validar o CAPTCHA');
jQuery.validator.methodGroup = function (name, rules, message) {
    message = message || 'Campo com erro';

    function getMessage() {
        return message;
    }

    jQuery.validator.addMethod(name, function (value, element) {
        for (var x = 0; x < rules.length; x++) {
            var rule = rules[x];
            var check = jQuery.validator.methods[rule.rule];

            if (check && !check.apply(this, [value, element, rule.param])) {
                message = jQuery.validator.messages[rule.rule];
                message = $.isFunction(message) ? message.apply(this, rule.param) : message
                return false;
            }
        }

        return true;
    }, getMessage);
}

jQuery.validator.addMethod("cnpj", function (value, element) {
    var numeros, digitos, soma, i, resultado, pos, tamanho, digitos_iguais;
    if (value.length == 0) {
        return true;
    }

    value = value.replace(/\D+/g, '');
    digitos_iguais = 1;

    for (i = 0; i < value.length - 1; i++)
        if (value.charAt(i) != value.charAt(i + 1)) {
            digitos_iguais = 0;
            break;
        }
    if (digitos_iguais)
        return false;

    tamanho = value.length - 2;
    numeros = value.substring(0, tamanho);
    digitos = value.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
        return false;
    }
    tamanho = tamanho + 1;
    numeros = value.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    return (resultado == digitos.charAt(1));
}, "Informe um CNPJ válido.")

jQuery.validator.addMethod("cpf", function (value, element) {
    var cpf, expReg, a, b, c, i, x, y;
    value = jQuery.trim(value);

    value = value.replace('.', '');
    value = value.replace('.', '');
    cpf = value.replace('-', '');
    while (cpf.length < 11) cpf = "0" + cpf;
    expReg = /^0+$|^1+$|^2+$|^3+$|^4+$|^5+$|^6+$|^7+$|^8+$|^9+$/;
    a = [];
    b = new Number;
    c = 11;
    for (i = 0; i < 11; i++) {
        a[i] = cpf.charAt(i);
        if (i < 9) b += (a[i] * --c);
    }
    if ((x = b % 11) < 2) { a[9] = 0 } else { a[9] = 11 - x }
    b = 0;
    c = 11;
    for (y = 0; y < 10; y++) b += (a[y] * c--);
    if ((x = b % 11) < 2) { a[10] = 0; } else { a[10] = 11 - x; }
    if ((cpf.charAt(9) != a[9]) || (cpf.charAt(10) != a[10]) || cpf.match(expReg)) return false;
    return true;
}, "Informe um CPF válido.");

jQuery.validator.addMethod("cep", function (value, element) {
    return this.optional(element) || /^[0-9]{5}-[0-9]{3}$/.test(value);
}, "Informe um CEP válido");

jQuery.validator.addMethod("phone", function (value, element) {
    return this.optional(element) || /^\([0-9]{2}\)\s[0-9]{4,5}-[0-9]{4}$/.test(value);
}, "Informe um numero válido");

jQuery.validator.addMethod("money", function (value, element) {
    return this.optional(element) || /^([0-9]+\.)*(\d{1,3}\,)(\d{2})$/.test(value);
}, "Informe um valor válido");

jQuery.validator.addMethod("money-min", function (value, element, p3, p4) {
    return this.optional(element) || jQuery.validator.methods.min.apply(this, [value.replace(/[^0-9\,]/g, "").replace(/[\,]/g, "."), element, p3, p4]);
}, "O valor deve ser no mínimo R$ {0}.");

jQuery.validator.addMethod("money-max", function (value, element, p3, p4) {
    return this.optional(element) || jQuery.validator.methods.max.apply(this, [value.replace(/[^0-9\,]/g, "").replace(/[\,]/g, "."), element, p3, p4]);
}, "O valor deve ser até R$ {0}.");

jQuery.validator.addMethod("branch", function (value, element, p3, p4) {
    return this.optional(element) || jQuery.validator.methods.minlength.apply(this, [value.replace(/[^0-9\,]/g, ""), element, p3, p4]);
}, "Campo deve conter no mínimo {0} digitos.");

jQuery.validator.addMethod("barcode", function (value, element) {
    return this.optional(element) || /^(\d{5})\.(\d{5})\s(\d{5})\.(\d{6})\s(\d{5})\.(\d{6})\s(\d{1})\s(\d{14})$/.test(value);
}, "Informe um valor válido");

jQuery.validator.addMethod("document", function (value, element) {
    return this.optional(element) || (
        jQuery.validator.methods.cpf.apply(this, arguments) || jQuery.validator.methods.cnpj.apply(this, arguments)
    );
}, "Informe um documento válido");

jQuery.validator.addMethod("login", function (value, element) {
    return this.optional(element) || (
        jQuery.validator.methods.cpf.apply(this, arguments) || jQuery.validator.methods.cnpj.apply(this, arguments) || jQuery.validator.methods.email.apply(this, arguments)
    );
}, "Informe um login válido");


jQuery.validator.addMethod('lettersonly', function (value, element) {
    return this.optional(element) || /^[a-z áãâäàéêëèíîïìóõôöòúûüùçñ]+$/i.test(value);
}, "Campo deve conter apenas letras e espaços");

jQuery.validator.addMethod('completename', function (value, element) {
    return this.optional(element) || /^.+\s.+$/i.test(value);
}, "Campo deve conter nome e sobrenome");

jQuery.validator.addMethod('requiredoraudio', function (value, element) {
    return jQuery.validator.methods.required.apply(this, arguments) || $(element).parents('label').find('audio').length > 0;
}, "Campo obrigatório");

jQuery.validator.addMethod('server', function (value, element, param, method) {
    var executeValidation = function (token) {
        return jQuery.validator.methods.remote.apply(this, [value, element, {
            url: $(element).attr('data-rule-server'),
            type: $(element).attr('data-method-server') || "post",
            data: {
                'g-recaptcha-response': token,
              email: function() {
                return $( element ).val();
              }
            },
            dataFilter: function(data, type){
                return !(/true/gim.test(data));
            },
            complete:function () {
                var el = $('.render-captcha--'+$(element).attr('data-captcha'));
                if (el.length) {
                    grecaptcha.reset(el.data('captcha-id'));
                }
            }
        }, "server"]);
    }
    var el = $('.render-captcha--'+$(element).attr('data-captcha'));
    if (el.length) {
        var promise = el.data('captcha-promise');
        if (promise) {
            promise.progress(executeValidation.bind(this));
            el.data('captcha-promise', false);
        }
        grecaptcha.execute(el.data('captcha-id'));
        return this.optional(element) || 'pending';
    }  else {
        return this.optional(element) || executeValidation();
    }
}, "Campo obrigatório");


jQuery.validator.methodGroup('fullname', [
    { rule: 'lettersonly' },
    { rule: 'completename' },
    { rule: 'rangelength', param: [5, 75] }
]);


module.exports = Form;



// WEBPACK FOOTER //
// ./resources/scripts/behaviors/Form.js